var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 462,
    viewBox: "0 0 375 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319.336 701.383L342.11 429.141L631.823 567.962L459.816 319.861L746.794 150.226L358.125 222.222L300.853 0.000231926L235.809 204.061L-44.8268 113.062L153.307 274.351L-142.523 374.827L150.198 384.434L28.7066 578.639L217.533 446.018L319.336 701.383Z",
    fill: "url(#paint0_linear_557_4425)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_557_4425",
    x1: -124.595,
    y1: 369.488,
    x2: 509.548,
    y2: 127.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#115EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#115EF3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBgMobile);
export default __webpack_public_path__ + "static/media/hero-bg-mobile.c3521fb06c3e2add35d5aa53bf73436b.svg";
export { ForwardRef as ReactComponent };